import { useDataSourceColumns } from "@/hooks";
import type { ColumnNameTransformer } from "@/types/workspace";
import { Flex, Input, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerColumnName({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: ColumnNameTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: ColumnNameTransformer) => void;
  index: number;
}) {
  const [column, setColumn] = useState(data.item_list[0]?.column || "");
  const [newName, setNewName] = useState(data.item_list[0]?.new_name || "");
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    setColumn(data.item_list[0]?.column || "");
    setNewName(data.item_list[0]?.new_name || "");
  }, [data.item_list]);

  const handleColumnChange = (value: string | null) => {
    if (value !== null) {
      setColumn(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [{ column: value, new_name: newName }],
        });
      }
    }
  };

  const handleNameChange = (value: string) => {
    setNewName(value);
    if (onUpdate) {
      onUpdate({
        ...data,
        item_list: [{ column, new_name: value }],
      });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Flex direction="row" gap={8}>
        <Select
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Column"
          data={availableColumns.length > 0 ? availableColumns : []}
          value={column}
          onChange={handleColumnChange}
        />
        <Input
          variant="light"
          bdrs="sm"
          bg="#F1F3F4"
          placeholder="Name"
          value={newName}
          onChange={(e) => handleNameChange(e.target.value)}
        />
      </Flex>
    </TransformerBase>
  );
}
